import React from 'react';

import Select from '../../../../../shared/design-system/components/select';
import { Placement } from '../../../../../shared/design-system/components/overlay';

type IProps = {
  className?: string;
  selectClassName?: string;
  placeholder?: string;
  options: any[];
  optionRenderer: (option) => React.ReactNode;
  selectedOptionKey: string;
  selectedOptionRenderer: (option) => React.ReactNode;
  onChange: (option) => void;
  isLoading?: boolean;
  showSearch?: boolean;
  onKeyDown?: (
    value: string,
    event: React.KeyboardEvent<HTMLInputElement>,
  ) => void;
  filterOption?: (search: string, option: any, options: any[]) => boolean;
  parentRef?: React.Ref<HTMLDivElement>;
  disabled?: boolean;
};

const ProspectFiltersSelectDropdown: React.FC<IProps> = ({
  className,
  selectClassName,
  placeholder,
  options,
  optionRenderer,
  selectedOptionKey,
  selectedOptionRenderer,
  onChange,
  isLoading = false,
  showSearch = false,
  onKeyDown = () => null,
  filterOption = () => true,
  children,
  parentRef = null,
  disabled = false,
}) => (
  <div className={`prospect-filters-select ${className}`} ref={parentRef}>
    <Select
      className={`prospect-filters-select-dropdown ${selectClassName}`}
      options={options}
      placement={Placement.BottomStart}
      selectedOptionKey={selectedOptionKey}
      placeholder={placeholder}
      optionRenderer={(option) => optionRenderer(option)}
      onChange={([option]) => {
        onChange(option);
      }}
      selectedOptionRenderer={([option]) => selectedOptionRenderer(option)}
      isLoading={isLoading}
      showSearch={showSearch}
      autoFocusSearch={showSearch}
      onKeyDown={onKeyDown}
      filterOption={filterOption}
      disabled={disabled}
    />
    {children}
  </div>
);

export default ProspectFiltersSelectDropdown;
